import { memo } from 'react'
import { BaseQuantityInput } from './BaseQuantityInput'

interface QuantityUnitInputProps {
  quantity: string
  unit: string
  showCustomUnitInput: boolean
  customUnit: string
  onQuantityChange: (quantity: string) => void
  onUnitChange: (unit: string) => void
  onCustomUnitChange: (value: string) => void
  onUnitDropdownClose: (open: boolean) => void
  placeholder?: string
}

export const QuantityUnitInput = memo<QuantityUnitInputProps>(function QuantityUnitInput(props) {
  return (
    <BaseQuantityInput
      {...props}
      label="per"
      labelWidth="narrow"
      ariaLabel="Price per quantity"
    />
  )
})

QuantityUnitInput.displayName = 'QuantityUnitInput'